import { BuildClass } from '../../../universal';
import { React } from '../../lib';
import { setContextMenu } from './context-menu';
import { stubImage } from './stubs';
export const KebabMenu = (props) => {
    const refImg = React.useRef(stubImage);
    const [isOpen, setIsOpen] = React.useState(false);
    const openMenu = () => {
        const rect = refImg.current.getBoundingClientRect();
        const left = (props.preferLeft ?? false) ? rect.right : rect.left;
        const top = rect.bottom;
        setIsOpen(true);
        setContextMenu({
            position: {
                x: left + (props.offset?.x ?? 0),
                y: top + (props.offset?.y ?? 0),
                preferLeft: props.preferLeft,
            },
            items: props.items,
            width: props.width,
            onClose: () => {
                setIsOpen(false);
                props.onClose?.();
            },
        });
    };
    React.useEffect(() => {
        if (isOpen) {
            openMenu();
        }
    }, [isOpen, props.items.length]);
    return (React.createElement("button", { className: BuildClass(props.className?.div ?? ''), onMouseDown: (e) => {
            e.preventDefault();
            if (props.stopPropagation) {
                e.stopPropagation();
            }
            openMenu();
        }, onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            openMenu();
        }, title: props.title ?? 'Click for more options' },
        React.createElement("img", { ref: refImg, className: BuildClass(props.className?.img ?? ''), src: props.img ?? '/static/img/svg/kebab.svg', alt: "Kebab Menu" })));
};
export const KebabMenuToolbar = (props) => (React.createElement("div", { className: BuildClass([
        'relative w-4 h-8 left-[-2px] mr-[2px]',
        'inline-flex items-center justify-center',
        'opacity-70 hover:opacity-100',
    ]) },
    React.createElement(KebabMenu, { ...props, offset: {
            y: 5,
            ...props.offset,
        }, className: {
            div: [
                'absolute w-8 h-8 left-[-8px]',
                'flex items-center justify-center',
                'border border-transparent rounded-[3px]',
                'focus:border-[#ccc]',
                'cursor-pointer hover:bg-[#ffc] hover:border-[#ccc]',
                'hover:shadow-[0_8px_5px_-5px_rgba(0,0,0,0.25),0_1px_2px_rgba(0,0,0,0.15),0_0_20px_rgba(0,0,0,0.05)_inset]',
            ],
            img: ['w-4 h-4'],
        } })));
//# sourceMappingURL=kebab.js.map